var getCamelCaseToSeparateWords = function (stringToFormat) {
    return stringToFormat
        .replace(/([A-Z])/g, ' $1')
        .trim()
        .toLocaleLowerCase();
};
export default getCamelCaseToSeparateWords;
